
import { useEffect, useState } from 'react';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16 sm:pt-20">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e75b73819fc81d7c430cea577eda37be.jpg"
          alt="Desguace en Gavá - Compramos coches siniestrados y averiados"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 text-center w-full py-8 sm:py-12">
        {/* Badge de confianza */}
        <div 
          className={`inline-flex flex-wrap items-center justify-center gap-2 bg-emerald-600/90 backdrop-blur-sm text-white px-3 sm:px-5 py-2 rounded-full mb-6 sm:mb-8 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'
          }`}
        >
          <div className="flex items-center space-x-1">
            <i className="ri-verified-badge-fill text-base sm:text-lg"></i>
            <span className="text-xs sm:text-sm font-medium">+15 Años en Gavá</span>
          </div>
          <span className="text-emerald-200 hidden sm:inline">|</span>
          <div className="flex items-center space-x-1">
            <i className="ri-star-fill text-yellow-400"></i>
            <span className="text-xs sm:text-sm font-medium">4.9/5</span>
          </div>
        </div>

        <h1 
          className={`text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight transition-all duration-700 delay-150 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="text-emerald-400">Desguace en Gavá</span>
          <br className="hidden sm:block" />
          <span className="sm:hidden"> - </span>
          Compramos tu Coche
          <br />
          Siniestrado o Averiado
          <br />
          <span className="text-xl sm:text-3xl md:text-4xl lg:text-5xl">con Pago Inmediato</span>
        </h1>
        
        <p 
          className={`text-sm sm:text-lg md:text-xl text-white/95 mb-4 sm:mb-6 max-w-4xl mx-auto leading-relaxed transition-all duration-700 delay-300 px-2 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <strong>¿Tienes un coche siniestrado o averiado en Gavá?</strong> Te ofrecemos la <strong>mejor valoración</strong>, recogida con grúa <strong>100% gratuita</strong> y <strong>pago al instante</strong>.
        </p>

        <p 
          className={`text-xs sm:text-base md:text-lg text-white/85 mb-6 sm:mb-10 max-w-3xl mx-auto leading-relaxed transition-all duration-700 delay-400 px-2 hidden sm:block ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Nos encargamos de <strong>toda la documentación</strong>: baja de tráfico y certificado de destrucción. 
          Servicio en <strong>Gavá, Castelldefels, Viladecans y toda la comarca</strong>.
        </p>

        {/* Botones de acción principales */}
        <div 
          className={`flex flex-col gap-3 sm:flex-row sm:flex-wrap items-center justify-center sm:gap-4 mb-6 sm:mb-8 px-2 transition-all duration-700 delay-500 ${
            isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'
          }`}
        >
          <a
            href="tel:+34932932913"
            className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700 text-white px-6 sm:px-10 py-4 sm:py-5 rounded-lg font-bold text-base sm:text-lg transition-all hover:scale-105 shadow-2xl flex items-center justify-center space-x-2 sm:space-x-3 whitespace-nowrap"
          >
            <i className="ri-phone-fill text-xl sm:text-2xl"></i>
            <span>Llamar: 932 932 913</span>
          </a>
          <a
            href="https://wa.me/34932932913?text=Hola,%20quiero%20vender%20mi%20coche%20en%20Gavá"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-full sm:w-auto bg-white hover:bg-gray-100 text-gray-900 px-6 sm:px-10 py-4 sm:py-5 rounded-lg font-bold text-base sm:text-lg transition-all hover:scale-105 shadow-2xl flex items-center justify-center space-x-2 sm:space-x-3 whitespace-nowrap"
          >
            <i className="ri-whatsapp-fill text-xl sm:text-2xl text-green-600"></i>
            <span>WhatsApp Directo</span>
          </a>
          <button
            onClick={() => {
              const calculador = document.getElementById('calculador-precio');
              if (calculador) {
                calculador.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="w-full sm:w-auto bg-amber-500 hover:bg-amber-600 text-white px-6 sm:px-10 py-4 sm:py-5 rounded-lg font-bold text-base sm:text-lg transition-all hover:scale-105 shadow-2xl flex items-center justify-center space-x-2 sm:space-x-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calculator-fill text-xl sm:text-2xl"></i>
            <span>Calcular Precio</span>
          </button>
        </div>

        {/* Texto de urgencia */}
        <p 
          className={`text-emerald-400 font-semibold text-xs sm:text-base mb-6 sm:mb-10 transition-all duration-700 delay-600 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <i className="ri-time-fill mr-1 sm:mr-2"></i>
          Valoración GRATIS en menos de 2 horas
        </p>

        {/* Beneficios destacados */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 max-w-5xl mx-auto px-2">
          {[
            { icon: 'ri-truck-fill', title: 'Recogida GRATIS', subtitle: 'Grúa incluida' },
            { icon: 'ri-money-euro-circle-fill', title: 'Pago Inmediato', subtitle: 'Efectivo o transferencia' },
            { icon: 'ri-time-fill', title: 'En 24 Horas', subtitle: 'Recogemos tu coche' },
            { icon: 'ri-file-text-fill', title: 'Gestión Completa', subtitle: 'Baja y documentación' },
          ].map((benefit, index) => (
            <div 
              key={index}
              className={`bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl py-3 sm:py-5 px-2 sm:px-4 hover:bg-white/20 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${700 + index * 100}ms` : '0ms' }}
            >
              <div className="w-8 h-8 sm:w-12 sm:h-12 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3">
                <i className={`${benefit.icon} text-white text-sm sm:text-xl`}></i>
              </div>
              <p className="text-white font-bold text-xs sm:text-sm">{benefit.title}</p>
              <p className="text-white/70 text-[10px] sm:text-xs mt-0.5 sm:mt-1 hidden sm:block">{benefit.subtitle}</p>
            </div>
          ))}
        </div>

        {/* Keywords SEO visibles */}
        <div 
          className={`mt-6 sm:mt-10 flex flex-wrap justify-center gap-1.5 sm:gap-2 max-w-4xl mx-auto px-2 transition-all duration-700 delay-1000 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {['Desguace Gavá', 'Vender coche siniestrado', 'Chatarra coches', 'Grúa gratis'].map((tag, i) => (
            <span key={i} className="bg-white/5 text-white/80 px-2 sm:px-3 py-1 rounded-full text-[10px] sm:text-xs">{tag}</span>
          ))}
        </div>
      </div>

      {/* Indicador de scroll */}
      <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl sm:text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
